/**
 * Intro steps shown before the main confession screen.
 * Each step has a `message`, optional `sub`, and optional `image`.
 */
export const introSteps = [
  {
    message: () => "We've known each other for like... 1.5 months? I think?",
    sub: "Not that long, but somehow we've already talked a lot. Like, a lot a lot.",
  },
  {
    message: () => 'You know, right?',
    sub: 'I got laid off from my one and only job\u2026 and honestly, that really hurt.',
  },
  {
    message: () => 'But you were there.',
    sub: 'You really helped me stay sane through all of that, and honestly... that meant a lot to me.',
  },
  {
    message: () => 'And I really mean this.',
    sub: "I think I would've gone a little crazy if you weren't there.",
  },
  {
    message: () => 'So... thank you.',
    sub: 'For listening, for being around, and for helping me get through that phase.',
  },
  {
    message: () => 'We talked a lot.',
    sub: 'And honestly, I really enjoyed every bit of that.',
  },
  {
    message: () => 'Even if sometimes...',
    sub: "I know I couldn't always match your energy because of my introvert-y self \ud83d\ude2d",
  },
  {
    message: () => 'But still,',
    sub: 'talking to you became one of the nicest parts of my day.',
  },
  {
    message: () => 'And well...',
    sub: "I've said this before, but let me say it once again — I like your voice, I like your face, and yeah... I think you're really cute.",
  },
  {
    message: () => 'And also...',
    sub: "we've been pretty flirty too, haven't we? \ud83d\ude2d",
  },
  {
    message: () => 'So I think...',
    sub: 'you probably already knew how I felt this whole time.',
  },
  {
    message: () => 'But I told you before,',
    sub: 'I wanted to wait until we actually met in person.',
  },
  {
    message: () => 'And today...',
    sub: 'we finally did.',
  },
  {
    message: () => 'So now,',
    sub: 'I just want to keep the promise I made to you.',
  },
  {
    message: () => 'Because the truth is...',
    sub: 'I really, really like you.',
  },
  {
    message: () => "And if you'll let me...",
    sub: 'I want to be yours, and I want you to be mine.',
  },
];
